<template>
  <div class="nothingness-activity-wrapper">
    <NoWorksData noDataText="当前作品尚未发布" />
    <button class="ui-btn" @click="handleBackToHome">
      进入活动首页
    </button>
    <div class="back-wrapper" @click="handleBackToHome">
      <div class="icon icon-back"></div>
    </div>
  </div>
</template>

<script>
import NoWorksData from "@/components/NoWorksData"

export default {
  name: "nothingnessActivity",
  components: {
    NoWorksData
  },
  methods: {
    handleBackToHome() {
      this.$router.replace({ path: "/" })
    }
  }
}
</script>

<style lang="scss" scoped>
.nothingness-activity-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-top: 3rem;
  position: relative;
  .ui-btn {
    width: 3rem;
    height: 0.88rem;
    background: #f64e45;
    border-radius: 0.44rem;
    color: #ffffff;
    font-family: PingFangSC-Regular;
    font-size: 0.3rem;
    outline: none;
    border: none;
    line-height: 0.88rem;
    text-align: center;
    margin-top: 0.5rem;
    &[disabled] {
      opacity: 0.5;
    }
    &:active {
      opacity: 0.7;
    }
  }
  .back-wrapper {
    width: 0.8rem;
    height: 0.8rem;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0.3rem;
    left: 0.3rem;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    &:active {
      opacity: 0.7;
    }
    .icon-back {
      width: 0.48rem;
      height: 0.64rem;
      background: url("../../assets/images/nav_icon_back_white@1x.png") no-repeat center center;
      background-size: 0.3rem 0.48rem;
    }
  }
}
</style>
